import { render, staticRenderFns } from "./RequiredFilesAsIcons.vue?vue&type=template&id=0ad6ac7a&"
import script from "./RequiredFilesAsIcons.vue?vue&type=script&lang=js&"
export * from "./RequiredFilesAsIcons.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports